import type { YammerCache } from '@ms/yammer-libs-cache';
import { MemoryCache } from '@ms/yammer-libs-cache';

let tokenCache: YammerCache | undefined;

type InitializeAuthTokenCache = () => void;
export const initializeAuthTokenCache: InitializeAuthTokenCache = () => {
  tokenCache = new MemoryCache();
};

type GetAuthTokenCache = () => YammerCache | undefined;
export const getAuthTokenCache: GetAuthTokenCache = () => tokenCache;
